// import { isMobile } from '@libs/util'
import Index from './index.vue'
// import Mobile from './mobile.vue'
// export default isMobile() ? Mobile : Index
export default Index
